var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.auth)?_c('navbar'):_vm._e(),_c('div',{staticClass:"container-fluid p-0",class:{'margin-top-navbar' : _vm.$route.meta.auth}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }